import { IStop } from 'apps/fleet-planner/types/loads'
import { DISPLAY } from 'constants/display'

export const formatFacilityName = (stop: IStop) => {
  return stop.facility?.name || stop.address?.addressee || DISPLAY.empty
}
